import axiosClient from "./axiosClient";

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const nurseOutService = {
  getListNurseOut: async (params) => {
    const url =
      "/qlkhambenh/phieu-dieu-duong/list-phieu-dieu-duong-da-tiep-nhan";
    params = { ...params };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getNextPatient: async () => {
    const url = "/qlkhambenh/phieu-dieu-duong/benh-nhan-tiep-theo";

    const response = await axiosClient.get(url);
    return response.data;
  },
  getChieuCaoCanNangTienSu: async (id) => {
    const url = `/qlkhambenh/phieu-dieu-duong/get-chieu-cao-can-nang-tien-su?id=${id}`;

    const response = await axiosClient.get(url);
    return response.data;
  },
  getNurseForm: async (id) => {
    const url = "/qlkhambenh/phieu-dieu-duong";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  updateNurseForm: async (data) => {
    const url = "/qlkhambenh/phieu-dieu-duong";
    const params = { id: data?.id };
    const response = await axiosClient.put(url, data, { params: params });
    return response.data;
  },
  postJsonNurse: async (params) => {
    const url = `/qlkhambenh/json-dieu-duong`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  getJsonNurse: async (id) => {
    const url = `/qlkhambenh/json-dieu-duong/lay-bang-ma-phieu-dieu-duong`;
    const params = { idPhieuDieuDuong: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  updateDetails: async (data) => {
    const url = "/qlkhambenh/refraction";
    // const params = { data: data };
    const response = await axiosClient.put(url, data);
    return response;
  },
  // danh mục thuốc tra mắt
  getListDilate: async () => {
    const url = `/qlkhambenh/dm-thuoc-tra/list-dm-thuoc-tra?type=1`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getDilate: async (id) => {
    const url = `/qlkhambenh/dm-thuoc-tra`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  addDilate: async (params) => {
    const url = `/qlkhambenh/dm-thuoc-tra`;

    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editDilate: async (params) => {
    const url = `/qlkhambenh/dm-thuoc-tra?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteDilate: async (id) => {
    const url = `/qlkhambenh/dm-thuoc-tra`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  //hetttt
  //Lấy danh mục lệ đạo
  getListLeDao: async () => {
    const url = `/qlkhambenh/dm-le-dao/list-dm-le-dao`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  addLD: async (params) => {
    const url = `/qlkhambenh/dm-le-dao`;

    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editLD: async (params) => {
    const url = `/qlkhambenh/dm-le-dao?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteLD: async (id) => {
    const url = `/qlkhambenh/dm-le-dao`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  //Het
  //Lấy danh mục nhãn áp
  getListNA: async () => {
    const url = `/qlkhambenh/dm-nhan-ap/list-dm-nhan-ap`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  addNA: async (params) => {
    const url = `/qlkhambenh/dm-nhan-ap`;

    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editNA: async (params) => {
    const url = `/qlkhambenh/dm-nhan-ap?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteNA: async (id) => {
    const url = `/qlkhambenh/dm-nhan-ap`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  //Het
  postTraThuoc: async (params) => {
    const url = `/qlkhambenh/tra-thuoc`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  stopTraThuoc: async (id, data) => {
    const url = `/qlkhambenh/tra-thuoc`;
    const params = { id: id };
    const response = await axiosClient.put(url, data, { params: params });
    return response.data;
  },
  postStatusNurseForm: async (params) => {
    const url = `/qlkhambenh/phieu-dieu-duong/cap-nhat-trang-thai`;

    const response = await axiosClient.put(url, {}, { params: params });
    return response.data;
  },
  completeKCB: async (params) => {
    const url = `/qlkhambenh/phieu-dieu-duong/cap-nhat-trang-thai`;
    const response = await axiosClient.put(url, {}, { params: params });
    return response.data;
  },
};

export default nurseOutService;
